import React from 'react';
import { FiAward } from 'react-icons/fi';
import './TrustedBy.css';

const partners = [
  { name: 'Telkom', icon: '📡' },
  { name: 'MikroTik', icon: '🔌' },
  { name: 'Cisco', icon: '🌐' },
  { name: 'Fortinet', icon: '🛡️' },
  { name: 'CloudFlare', icon: '☁️' },
  { name: 'VMware', icon: '💻' },
  { name: 'Huawei', icon: '📱' },
  { name: 'Sophos', icon: '🔒' },
];

const TrustedBy = () => {
  return (
    <section className="trusted section">
      <div className="container">
        <div className="trusted__header">
          <FiAward className="trusted__header-icon" />
          <h3 className="trusted__title">Mitra Terpercaya Kami</h3>
          <p className="trusted__subtitle">
            Kami berkolaborasi dengan vendor teknologi terkemuka dunia untuk memberikan
            solusi terbaik bagi klien kami.
          </p>
        </div>
      </div>

      <div className="trusted__marquee">
        <div className="trusted__marquee-track">
          {[...partners, ...partners].map((partner, index) => (
            <div key={index} className="trusted__item">
              <span className="trusted__item-icon">{partner.icon}</span>
              <span className="trusted__item-name">{partner.name}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustedBy;
